import * as React from 'react';
import {
  MergeOrder,
  TopModelMergeNameTransformed,
} from '@goldwasserexchange/react-topmodel';
import { listInputDomDefaultTopModelsObject } from './topmodels';

export function DefaultListInputDomTopModelsProvider(
  props: React.PropsWithChildren<{ order?: MergeOrder }>,
) {
  const { children, order } = props;
  return (
    <TopModelMergeNameTransformed
      topModels={listInputDomDefaultTopModelsObject}
      order={order}
    >
      {children}
    </TopModelMergeNameTransformed>
  );
}
